export enum Rules {
  Atm = 'atm_disabled',
  ContactlessPayments = 'contactless_disabled',
  Ecommerce = 'ecommerce_disabled',
}